<template>
  <boxwrap class="faqs--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
          v-if="checkPermission"
        >
          <i class="ico--create"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{'data-loading': showDataLoading}"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>
      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input type="checkbox" @click="checkAll(faqs)">
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="title"
                :sort="true"
                @click.native="sort('title')"
                v-if="checkCol('title', tblSetting)"
              >
                title
              </tbl-td>

              <tbl-td
                name="content"
                :sort="true"
                @click.native="sort('content')"
                v-if="checkCol('content', tblSetting)"
              >
                content
              </tbl-td>

              <tbl-td
                name="type"
                :sort="true"
                @click.native="sort('type')"
                v-if="checkCol('type', tblSetting)"
              >
                type
              </tbl-td>

              <tbl-td
                name="admin"
                :sort="true"
                @click.native="sort('admin_id')"
                v-if="checkCol('admin', tblSetting)"
              >
                admin
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(faq, index) in faqs"
              :key="index"
              @click.native="showModifyPopUp(faq)"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="faq.id"
                  >
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(index, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ faq.created_at | date }}
              </tbl-td>

              <tbl-td
                name="title"
                v-if="checkCol('title', tblSetting)"
                :isHtml="true"
                :logs="faq.title"
              >
              </tbl-td>

              <tbl-td
                name="content"
                v-if="checkCol('content', tblSetting)"
                :isHtml="true"
                :logs="faq.content"
              >
              </tbl-td>

              <tbl-td
                name="type"
                v-if="checkCol('type', tblSetting)"
              >
                {{ faq.type }}
              </tbl-td>

              <tbl-td
                name="admin"
                v-if="checkCol('admin', tblSetting)"
              >
                {{ faq.admin.login_name }}
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ faq.updated_at | date }}
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ faq.deleted_at | date }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            v-model="params.page"
            :total="count"
            :limit="params.rows"
            :rows="params.rows"
            @page="trigger">
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>

    <modal
      class="modal--create-faq"
      :title="'create faq'"
      :activate="showCreate"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showCreate"
      @activate="event => { showCreate = event }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="createParams.title"
                >
                </quill-editor>
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="createParams.content"
                ></quill-editor>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="save(createParams)"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-faq"
      :title="'modify faq'"
      :activate="showModify"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showModify"
      @activate="event => { showModify = event,
        hideModifyPopUp(updateParams) }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>Created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ updateParams.created_at | date }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ updateParams.updated_at | date }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ updateParams.deleted_at | date }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl -content"><span>title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="updateParams.title"
                >
                </quill-editor>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl -content"><span>content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="updateParams.content"
                ></quill-editor>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="modify(selected, faqs, updateParams)"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { swal } from '@/assets/js/mixins/base/Swal'

// == components
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import CheckDataList from '@/components/base/CheckDataList'
import Search from '@/components/base/search/Search'
import { quillEditor } from 'vue-quill-editor'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    Pagination,
    Modal,
    Checkbox,
    CheckDataList,
    Search,
    'quill-editor': quillEditor
  },

  mixins: [ swal ],

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,

      createParams: {
        title: '',
        content: '',
        user_id: 1
      },

      updateParams: {
        id: '',
        title: '',
        content: ''
      },

      filterBy: [
        {
          value: 'title',
          display: 'title'
        },

        {
          value: 'content',
          display: 'content'
        },

        {
          value: 'type',
          display: 'type'
        },

        {
          value: 'admin_id',
          display: 'admin'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      showCreate: false,
      showModify: false,
      selectAll: false,
      selected: [],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,
      status: 'all',

      showTblSettings: false,
      tblSetting: 'faqs_rules',
      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'title',
          value: 'title'
        },
        {
          display: 'content',
          value: 'content'
        },
        {
          display: 'type',
          value: 'type'
        },
        {
          display: 'admin',
          value: 'admin_id'
        },
        {
          display: 'user',
          value: 'user_id'
        },
        {
          display: 'created-at',
          value: 'created_at'
        },
        {
          display: 'updated-at',
          value: 'updated_at'
        },
        {
          display: 'deleted-at',
          value: 'deleted_at'
        }
      ],

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  computed: {
    ...mapState('faq', ['faqs', 'count']),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      console.log(obj)
      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.params = this.generate(this.params)
    this.search()
  },

  methods: {
    ...mapActions('faq', ['get', 'create', 'update']),

    trigger (q) {
      let s = this.$route.params.status
      this.params = q || this.params
      this.$router.push({ path: `/support/faqs/${s}`, query: this.params })
    },

    async search (q) {
      this.params = q || this.params
      this.status = this.$route.params.status

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({ status: this.status, params: this.params })

      this.isDataLoading = false
      this.showDataLoading = false

      if (!this.faqs.length) {
        this.isEmpty = true
      }
    },

    async save (params) {
      let success = async () => {
        let result = await this.create(params)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created faq.', {}, '', 'Success')
          this.resetParams('create')
          this.search()
        }
      }

      if (params.title === '') {
        this.$alert('error', 'Missing title data.', {}, '', 'Error')
        return
      }

      if (params.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Missing title data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create FAQ')
    },

    async modify (selected, faqs, faq) {
      let success = async () => {
        let params = []
        let result

        if (!faq) {
          faqs.forEach((data) => {
            selected.forEach((v, k) => {
              if (data.id === v) {
                params.push(data)
              }
            })
          })
        } else {
          faqs.forEach((data) => {
            if (data.id === faq.id) {
              data.title = faq.title
              data.content = faq.content
              params.push(data)
            }
          })
        }

        result = await this.update(params)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified faq.', {}, '', 'Success')
          this.resetParams('update')
        }
      }

      if (faq.title === '') {
        this.$alert('error', 'Missing title data.', {}, '', 'Error')
        return
      }

      if (faq.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Missing title data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to modify faq?', {}, { success }, 'Modify FAQ')
    },

    setSelected (id) {
      this.selected.push(id)
      this.selected = this.selected.filter((val, idx, arr) => {
        return arr.indexOf(val) === idx
      })
    },

    resetParams (data = null) {
      if (data === 'filter') {
        this.params = {
          page: 1,
          rows: 50,
          filter_by: '',
          q: '',
          sort_by: 'id',
          sort: 'desc',
          date_from: '',
          date_to: ''
        }
      }

      if (data === 'create') {
        this.createParams = {
          title: '',
          content: '',
          user_id: 1
        }
        this.showCreate = false
      }

      if (data === 'update') {
        this.updateParams = {
          id: '',
          title: '',
          content: ''
        }
        this.showModify = false
      }

      this.selected = []
      this.selectAll = false
    },

    showModifyPopUp (data) {
      if (this.checkPermission) {
        this.selected.push(data.id)
        this.showModify = true
        this.updateParams.id = data.id
        this.updateParams.title = data.title
        this.updateParams.content = data.content
        this.updateParams.created_at = data.created_at
        this.updateParams.updated_at = data.updated_at
        this.updateParams.deleted_at = data.deleted_at
      }
    },

    hideModifyPopUp (data) {
      let idx = this.selected.indexOf(data.id)

      this.selected.splice(idx, 1)
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    }
  }
}
</script>
